module.exports = __webpack_public_path__ + "images/corona2020_smalla70b0d86a48d8b48a802b05202fd0e3c.png";